const forgotPassword = document.querySelector('.forgot-password');

if(forgotPassword) {

  const $resetPassword = $('.reset-password');

  $resetPassword.on('submit', e => {

    e.preventDefault();

    const $button = $resetPassword.find('button[type="submit"]');
    const $message = $resetPassword.find('.reset-password__message');

    $button.attr('disabled', true);

    window.apiRequestNoToken('post', '/reset-password', $resetPassword.serialize()).then(r => {

      $message.html(r.message);

      if(r.type === 'error') {
        $button.attr('disabled', false);
      } else {
        setTimeout(() => {
          window.location = window.site.home;
        }, 5000);
      }

    });

  });

}
